import React from 'react';
import { useTheme } from '@mui/material/styles';
import { StyledSyncIcon } from './RefreshButton.style';

const RefreshButton = ({
  handleSyncIconClick,
  isDisabled,
  SyncIconStyle,
}: any) => {
  const theme = useTheme();
  return (
    <StyledSyncIcon
      data-testid="refresh-button-icon"
      onClick={(e: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (!isDisabled) handleSyncIconClick();
      }}
      sx={isDisabled ? {} : SyncIconStyle}
      style={{
        color: theme.palette.text.disabled,
        opacity: isDisabled ? 0.5 : 1,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
      }}
    />
  );
};

export default RefreshButton;
